import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'
import { Settings, SettingsService } from './services/settings.service'
import { EnvironmentService } from '@surgetech-eu/core'

@Injectable()
export class SettingsResolver {
    constructor(
        private settingsService: SettingsService,
        private env: EnvironmentService
    ) {
        //
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Settings> {
        return this.settingsService.get(this.env.get().organization === 'kering' ? this.env.get().organization : '')
    }
}
